import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { DropdownMenu } from '@3plearning/react-components';
import { FlexWrapper, FilterWrapper } from './styled';
import { getGroups } from '../filters/filters-util';
import { getTypeSelectList, getSelectedTypeOption } from '../assessment-filter/assessment-filter-util';
import { getLearningGaps, getLearningGapsPerStudent } from '../../containers/link-upf-modal/link-upf-modal-actions';
import { AssessmentsIcon, FilterIcon } from '../../helpers/icon-dictionary';
import SvgIcon from '../svg-icon/svg-icon';

const LearningGapsModalFilters = ({ i18n, groupSelection, onGroupChange, isGroupData }) => {
  const {
    classrooms,
    selectedClassRoom,
    assessmentTypes,
    selectedAssessmentType: assessmentTypeSelection,
    selectedCourse
  } = useSelector(state => state.UPFAssignReducer);
  const groups = getGroups(selectedClassRoom.value, classrooms, i18n);
  const [selectedAssessmentType, setSelectedAssessmentType] = useState(assessmentTypeSelection);
  const selectedProduct = useSelector(state => state.product);
  const dispatch = useDispatch();

  const onAssessmentTypeChange = ({ value, label }) => {
    setSelectedAssessmentType({ id: value, name: label });
  };

  useEffect(() => {
    const request = {
      productId: selectedProduct && selectedProduct.id,
      assessmentId: selectedCourse && selectedCourse.id,
      version: selectedCourse && selectedCourse.version,
      type: selectedAssessmentType.id,
      classroomId: selectedClassRoom.value
    };

    if (isGroupData) {
      dispatch(getLearningGaps({
        ...request,
        groupId: groupSelection.value === '-1' ? 0 : groupSelection.value,
        profileId: 0
      }));
    } else {
      dispatch(getLearningGapsPerStudent({
        ...request,
        isGetMoreLJs: true
      }));
    }
  }, [groupSelection, selectedAssessmentType, isGroupData]);

  return (
    <FlexWrapper>
      {isGroupData && <FilterWrapper>
        <label htmlFor="groups">
          <SvgIcon icon={FilterIcon} />
          <span>{i18n.t`Filter students by...`}</span>
        </label>
        <DropdownMenu
          key="groups"
          options={groups}
          selectedOption={groupSelection}
          onSelectOption={onGroupChange}
        />
      </FilterWrapper>}
      <FilterWrapper>
        <label htmlFor="type">
          <SvgIcon icon={AssessmentsIcon} />
          <span>{i18n.t`Assessment type`}</span>
        </label>
        <DropdownMenu
          key="assessment-type"
          options={getTypeSelectList(assessmentTypes)}
          onSelectOption={onAssessmentTypeChange}
          selectedOption={getSelectedTypeOption(selectedAssessmentType)}
        />
      </FilterWrapper>
    </FlexWrapper>
  );
};

LearningGapsModalFilters.propTypes = {
  i18n: PropTypes.object,
  groupSelection: PropTypes.object,
  onGroupChange: PropTypes.func,
  isGroupData: PropTypes.bool
};

export default LearningGapsModalFilters;
